import getField from '../getField'
import urlForUser from '../../urlForUser'

const getUserProfileLocation = user => urlForUser(getField(user, 'userProfile') || user)

export default getUserProfileLocation



// WEBPACK FOOTER //
// ./src/utilities/Data/User/getUserProfileLocation.js